import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fire-and-forget page view tracker. Sends one event to the backend
 * every time the visible pathname changes. Skips admin routes to keep
 * the numbers meaningful for the *public* funnel only.
 *
 * Deliberately mounted once at the top of App so a global effect handles
 * all client-side navigation without touching individual pages.
 */
export default function usePageViewTracker() {
  const { pathname } = useLocation();
  const lastPathRef = useRef(null);

  useEffect(() => {
    if (!pathname || pathname === lastPathRef.current) return;
    // Don't track admin / debug routes — those don't reflect real visitors.
    if (pathname.startsWith('/admin')) return;
    lastPathRef.current = pathname;
    // Fire-and-forget. Errors are silently swallowed by axios+catch.
    axios.post(
      `${API}/analytics/track`,
      { path: pathname, referrer: document.referrer || null },
      { withCredentials: false },
    ).catch(() => { /* ignore */ });
  }, [pathname]);
}
